import { useStore } from 'engine/store';
import { useEffect, useRef, type ReactNode } from 'react';
import { skinToCSSVariables } from 'shared/modelTypes/skin';

export const SkinProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const skin = useStore((s) => s.skin);

	const titleFontLinkRef = useRef<HTMLLinkElement | null>(null);
	const textFontLinkRef = useRef<HTMLLinkElement | null>(null);

	useEffect(() => {
		if (titleFontLinkRef.current) {
			titleFontLinkRef.current.remove();
			titleFontLinkRef.current = null;
		}

		if (skin.skinFont) {
			const fontName = skin.skinFont.replace('/\\s/g', '+');
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = `https://fonts.googleapis.com/css2?family=${fontName}`;
			document.head.appendChild(link);
			titleFontLinkRef.current = link;
		}
	}, [skin.skinFont]);

	useEffect(() => {
		if (textFontLinkRef.current) {
			textFontLinkRef.current.remove();
			textFontLinkRef.current = null;
		}

		if (skin.skinTextFont) {
			const fontName = skin.skinTextFont.replace('/\\s/g', '+');
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = `https://fonts.googleapis.com/css2?family=${fontName}`;
			document.head.appendChild(link);
			textFontLinkRef.current = link;
		}
	}, [skin.skinTextFont]);

	return <div style={skinToCSSVariables(skin, import.meta.env.VITE_CDN)}>{children}</div>;
};
